var n=function(n){return function(r){return null==r?void 0:r[n]}};export{n as default};
//# sourceMappingURL=_baseProperty.js.map
